import router from './spa_setup';
import i18n from './i18n';

new window.Vue({
    router,
    i18n,
}).$mount('#app');
